import { atom } from 'jotai'

export const limitPickerModeAtom = atom(false)
